import { CLEAR_SESSION_ID, SET_SESSION_ID } from '../Actions/Types';

const initialState = {
  sessionId: null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload,
      };
    case CLEAR_SESSION_ID:
        return {
          ...state,
          sessionId: null,
      };
    default:
      return state;
  }
};

export default sessionReducer;
